module.exports = __webpack_public_path__ + "static/media/LocationMarker.1817f5b9.svg";